<template>
    <div>
        <div class="box">
            <div class="top-bar">
                <b-button @click="$router.go(-1)" class="level-item" type="is-light">
                    <b-icon icon="arrow-left" pack="fas" />
                    <span>Back</span>
                </b-button>
                <p class="sub-title">{{ isEdit ? "Edit" : "New" }} {{ itemName }}</p>
            </div>
            <hr />
            <div>
                <form @submit.prevent="formSubmit">
                    <b-field label="ID">
                        <b-input disabled v-model="form.id" />
                    </b-field>

                    <b-field
                        label="Parent Category"
                        :message="form.errors.get('parent_id')"
                        :type="{ 'is-danger': form.errors.has('parent_id') }"
                        expanded
                    >
                        <b-select placeholder="Select" v-model="form.parent_id" expanded>
                            <option :value="null">Non</option>
                            <option
                                v-for="(val, idx) in $store.getters.parentCategories"
                                :key="idx"
                                :value="val.id"
                                :disabled="val.id != 2"
                            >
                                {{ val.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-tabs type="is-boxed" expanded :animated="false">
                        <b-tab-item>
                            <template #header>
                                <img class="flag" src="/images/uk.png" />
                                <span> English </span>
                            </template>
                            <b-field grouped>
                                <b-field
                                    :message="form.errors.get('name_en')"
                                    :type="{ 'is-danger': form.errors.has('name_en') }"
                                    expanded
                                >
                                    <template slot="label"> Title English </template>
                                    <b-input placeholder="Title English" type="text" v-model="form.name_en" />
                                </b-field>
                            </b-field>
                            <hr />
                            <b-field
                                :message="form.errors.get('desc_en')"
                                :type="{ 'is-danger': form.errors.has('desc_en') }"
                                expanded
                            >
                                <template slot="label"> Short Description English </template>
                                <b-input
                                    placeholder="Short Description English"
                                    type="textarea"
                                    v-model="form.desc_en"
                                />
                            </b-field>
                            <b-field
                                :message="form.errors.get('short_desc_en')"
                                :type="{ 'is-danger': form.errors.has('short_desc_en') }"
                                expanded
                            >
                                <template slot="label"> Description English </template>
                                <b-input
                                    placeholder="Description English"
                                    type="textarea"
                                    v-model="form.short_desc_en"
                                />
                            </b-field>
                        </b-tab-item>

                        <b-tab-item>
                            <template #header>
                                <img class="flag" src="/images/krd.png" />
                                <span> Kurdish </span>
                            </template>

                            <b-field grouped>
                                <b-field
                                    :message="form.errors.get('name_ku')"
                                    :type="{ 'is-danger': form.errors.has('name_ku') }"
                                    expanded
                                >
                                    <template slot="label"> Title Kurdish </template>
                                    <b-input placeholder="Title Kurdish" type="text" v-model="form.name_ku" />
                                </b-field>
                            </b-field>
                            <hr />
                            <b-field
                                :message="form.errors.get('desc_ku')"
                                :type="{ 'is-danger': form.errors.has('desc_ku') }"
                                expanded
                            >
                                <template slot="label"> Short Description Kurdish </template>
                                <b-input
                                    placeholder="Short Description Kurdish"
                                    type="textarea"
                                    v-model="form.desc_ku"
                                />
                            </b-field>
                            <b-field
                                :message="form.errors.get('short_desc_ku')"
                                :type="{ 'is-danger': form.errors.has('short_desc_ku') }"
                                expanded
                            >
                                <template slot="label"> Description Kurdish </template>
                                <b-input
                                    placeholder="Description Kurdish"
                                    type="textarea"
                                    v-model="form.short_desc_ku"
                                />
                            </b-field>
                        </b-tab-item>
                        <b-tab-item>
                            <template #header>
                                <img class="flag" src="/images/iq.png" />
                                <span> Arabic </span>
                            </template>

                            <b-field grouped>
                                <b-field
                                    :message="form.errors.get('name_ar')"
                                    :type="{ 'is-danger': form.errors.has('name_ar') }"
                                    expanded
                                >
                                    <template slot="label"> Title Arabic </template>
                                    <b-input placeholder="Title Arabic" type="text" v-model="form.name_ar" />
                                </b-field>
                            </b-field>
                            <hr />
                            <b-field
                                :message="form.errors.get('desc_ar')"
                                :type="{ 'is-danger': form.errors.has('desc_ar') }"
                                expanded
                            >
                                <template slot="label"> Short Description Arabic </template>
                                <b-input
                                    placeholder="Short Description Arabic"
                                    type="textarea"
                                    v-model="form.desc_ar"
                                />
                            </b-field>
                            <b-field
                                :message="form.errors.get('short_desc_ar')"
                                :type="{ 'is-danger': form.errors.has('short_desc_ar') }"
                                expanded
                            >
                                <template slot="label"> Description Arabic </template>
                                <b-input
                                    placeholder="Description Arabic"
                                    type="textarea"
                                    v-model="form.short_desc_ar"
                                />
                            </b-field>
                        </b-tab-item>
                    </b-tabs>

                    <b-field
                        label="Sort"
                        :message="form.errors.get('sort')"
                        :type="{ 'is-danger': form.errors.has('sort') }"
                        expanded
                    >
                        <b-input placeholder="Description Arabic" type="number" v-model="form.sort" />
                    </b-field>

                    <b-field
                        label="URI"
                        :message="form.errors.get('slug')"
                        :type="{ 'is-danger': form.errors.has('slug') }"
                        expanded
                    >
                        <b-input
                            placeholder="Slug"
                            type="text"
                            v-model="form.slug"
                            :disabled="this.$route.path.indexOf('new') == -1 ? true : false"
                        />
                    </b-field>

                    <b-field
                        label="Active"
                        :message="form.errors.get('is_active')"
                        :type="{ 'is-danger': form.errors.has('is_active') }"
                        expanded
                    >
                        <b-switch v-model="form.is_active" />
                    </b-field>

                    <b-field
                        label="Filter By"
                        :message="form.errors.get('filter_by')"
                        :type="{ 'is-danger': form.errors.has('filter_by') }"
                        expanded
                    >
                        <b-select placeholder="Filter Name..." v-model="form.filter_by" expanded>
                            <option :value="null"></option>
                            <option value="country">Country</option>
                            <option value="sector">Sector</option>
                        </b-select>
                    </b-field>

                    <!-- New Only -->
                    <template v-if="form.filter_by != undefined">
                        <!-- Filters -->
                        <b-field
                            v-if="!this.isEdit"
                            :message="form.errors.get('filters')"
                            :type="{ 'is-danger': form.errors.has('filters') }"
                            expanded
                        >
                            <template #label>
                                Filters
                                <b-tooltip type="is-dark" label="Add new filter">
                                    <div class="pointer" @click="filters.push({ ar: '', en: '', ku: '' })">
                                        <b-icon size="is-small" icon="plus-circle" type="is-success"></b-icon>
                                    </div>
                                </b-tooltip>
                            </template>
                            <b-field
                                v-for="(item, idx) in filters"
                                :label="`#${idx + 1}`"
                                horizontal
                                :key="idx"
                                :message="form.errors.get('filters')"
                                :type="{ 'is-danger': form.errors.has('filters') }"
                                expanded
                                group-multiline
                                grouped
                            >
                                <b-field
                                    :message="form.errors.get(`filters.${idx}.en`)"
                                    :type="{ 'is-danger': form.errors.has(`filters.${idx}.en`) }"
                                    expanded
                                >
                                    <b-input
                                        placeholder="English Filter"
                                        v-model="filters[idx].en"
                                        expanded
                                        :maxlength="45"
                                    />
                                </b-field>
                                <b-field
                                    :message="form.errors.get(`filters.${idx}.ar`)"
                                    :type="{ 'is-danger': form.errors.has(`filters.${idx}.ar`) }"
                                    expanded
                                >
                                    <b-input
                                        placeholder="Arabic Filter"
                                        v-model="filters[idx].ar"
                                        expanded
                                        :maxlength="45"
                                    />
                                </b-field>
                                <b-field
                                    :message="form.errors.get(`filters.${idx}.ku`)"
                                    :type="{ 'is-danger': form.errors.has(`filters.${idx}.ku`) }"
                                    expanded
                                >
                                    <b-input
                                        placeholder="Kurdish Filter"
                                        v-model="filters[idx].ku"
                                        expanded
                                        :maxlength="45"
                                    />
                                </b-field>
                                <div class="controls">
                                    <b-button @click="removeFilter(idx)"
                                        ><b-icon icon="delete" type="is-danger"
                                    /></b-button>
                                </div>
                            </b-field>
                        </b-field>

                        <!-- // ! EDIT FILTERS -->
                        <FiltersComponent :list.sync="filters" :categoryId="form.id" v-else />
                    </template>

                    <template v-else>
                        <!-- // EDIT -->
                    </template>

                    <!-- Sections -->
                    <b-field
                        label="Sections"
                        :message="form.errors.get('sections_ids')"
                        :type="{ 'is-danger': form.errors.has('sections_ids') }"
                        expanded
                    >
                        <OAuthcomplete
                            :dataList="$store.state.sections"
                            :searchFields="['name']"
                            field="name"
                            placeholder="Select Sections"
                            @selected="addSection"
                            picker
                        />
                    </b-field>
                    <!-- Sections List -->
                    <b-field
                        v-for="(item, idx) in sections"
                        :key="idx"
                        :message="form.errors.get(`sections_ids.${idx}`)"
                        :type="{ 'is-danger': form.errors.has(`sections_ids.${idx}`) }"
                        expanded
                    >
                        <b-input disabled v-model="item.name" expanded />
                        <div class="controls">
                            <b-button @click="sections.splice(idx, 1)"
                                ><b-icon icon="delete" type="is-danger"
                            /></b-button>
                        </div>
                    </b-field>

                    <b-field
                        label="Background Image"
                        :message="form.errors.get('image_id')"
                        :type="{ 'is-danger': form.errors.has('image_id') }"
                        expanded
                    >
                        <GalleryPicker type="image" @select="(id) => (form.image_id = id)" :initial="form.file" />
                    </b-field>

                    <b-field
                        label="Navigation Icon"
                        :message="form.errors.get('icon_id')"
                        :type="{ 'is-danger': form.errors.has('icon_id') }"
                        expanded
                    >
                        <GalleryPicker type="svg" @select="(id) => (form.icon_id = id)" :initial="form.icon" />
                    </b-field>

                    <b-field
                        label="Home Page Image"
                        :message="form.errors.get('home_image_id')"
                        :type="{ 'is-danger': form.errors.has('home_image_id') }"
                        expanded
                    >
                        <GalleryPicker
                            type="image"
                            @select="(id) => (form.home_image_id = id)"
                            :initial="form.home_image"
                        />
                    </b-field>

                    <div class="bottom-btns">
                        <b-button @click="$router.go(-1)" type="is-light">Cancel</b-button>
                        <b-button :loading="form.busy" native-type="submit" type="is-primary">Submit</b-button>
                    </div>
                </form>
                <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "../../../plugins/vForm";
import GalleryPicker from "../../../components/Files/GalleryPicker.vue";
import OAuthcomplete from "../../../components/oAutocomplete.vue";
import FiltersComponent from "../../../components/FiltersComponent.vue";
export default {
    components: {
        GalleryPicker,
        OAuthcomplete,
        FiltersComponent,
    },
    data() {
        return {
            itemName: "Category",
            apiURI: "/categories",
            isLoading: true,
            sections: [],
            filters: [{ en: "", ar: "", ku: "" }],
            form: new vform({
                id: null,
                name_en: "",
                name_ar: "",
                name_ku: "",
                sort: 0,
                desc_en: "",
                desc_ar: "",
                desc_ku: "",
                short_desc_en: "",
                short_desc_ar: "",
                short_desc_ku: "",
                slug: "",
                is_parent: false,
                is_active: false,
                parent_id: null,
                image_id: null,
                home_image_id: null,
                image: null,
                type: "project",
                filter_by: null,
                file: null,
                home_image: null,
                sections_ids: [],
                filters: [],
                icon_id: undefined,
                icon: null,
            }),
        };
    },
    methods: {
        async init() {
            let id = this.$route.params.id;
            // Edit Loading
            if (this.isEdit) {
                // If its not Number
                if (!id || !this.isNumber(id)) {
                    this.notify("Error fetching data.", "is-danger");
                    return;
                }
                try {
                    let res = await this.$http.get(`${this.apiURI}/${id}`);
                    res.data.active = res.data.active ? 1 : 0;
                    this.form.fill(res.data);
                    this.sections = res.data.sections;
                    this.filters = res.data.category_filters;
                } catch (err) {
                    this.notify(err, "is-danger");
                    return;
                }
            }
            this.isLoading = false;
        },
        formSubmit() {
            this.sectionPreprocess();
            if (this.isEdit) {
                // Edit request
                this.form.password = this.form.password == "" ? undefined : this.form.password;
                let update = () => {
                    this.form
                        .submit("post", this.apiURI + "/" + this.form.id)
                        .then(() => {
                            //Alert
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.itemName + " editied successfully.",
                                type: "is-success",
                            });
                            this.$router.go(-1);
                            // this.$store.dispatch("loadAPI", this.$axios);
                        })
                        .catch((err) => {
                            if (err.response.status != 422) {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Something went wrong.",
                                    position: "is-bottom",
                                    type: "is-danger",
                                });
                            }
                        });
                };
                if (this.form.password) {
                    // Password changed, alert for password change
                    this.$buefy.dialog.confirm({
                        title: "Changing password",
                        message:
                            "Are you sure you want to change the <b>password</b> this user? This action cannot be undone.",
                        confirmText: "Confirm",
                        type: "is-warning",
                        hasIcon: true,
                        onConfirm: update,
                    });
                } else {
                    update();
                }
            } else {
                // before submit
                this.preprocess();
                // Create request
                this.form
                    .submit("post", this.apiURI)
                    .then(() => {
                        //Alert
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.itemName + " created successfully.",
                            type: "is-success",
                        });
                        this.$router.go(-1);
                        // this.$store.dispatch("loadAPI", this.$axios);
                    })
                    .catch((err) => {
                        if (err.response.status != 422) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Something went wrong. Please try again.",
                                position: "is-bottom",
                                type: "is-danger",
                            });
                        }
                    });
            }
        },
        sectionPreprocess() {
            this.form.sections_ids = this.sections.map((item) => item.id);
        },
        preprocess() {
            if (this.form.filter_by != null) {
                this.form.filters = this.filters;
            } else {
                this.form.filters = [];
            }
        },
        removeFilter(idx) {
            this.filters.splice(idx, 1);
            if (this.filters.length <= 0) {
                this.filters = [{ en: "", ar: "", ku: "" }];
            }
        },
        addSection(item) {
            if (!item || item == null) {
                return;
            }
            if (!this.sections.some((s) => s.id == item.id)) {
                this.sections.push(item);
            }
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        isEdit() {
            if (this.$route.path.indexOf("new") == -1) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style>
.block {
    display: block;
}
.modal-form {
    position: relative;
}
img.preview-image {
    max-height: 180px;
    border-radius: 10px;
}
.flag {
    height: 20px;
    max-height: 20px;
    padding: 0px 10px;
}
</style>
